<div class="row">
  <div class="col-md-2">
    <nb-menu tag="menu" [items]="catList" status="primary" autoCollapse="false"></nb-menu>
  </div>
  <div class="col-md-10">
    <router-outlet></router-outlet>
  </div>
</div>
